// Products
export const PRODUCTS_FETCH = "products/fetch";

// Cart
export const CART_FETCH = "cart/fetch";
export const CART_ADD_ITEM = "cart/addItem";
export const CART_REMOVE_ITEM = "cart/removeItem";
export const CART_RESET = "cart/reset";
export const CART_RESET_CURRENT_ITEM = "cart/resetCurrentSim";
export const CART_UPDATE_CURRENT_ITEM = "cart/updateCurrent";
export const CART_UPDATE_CURRENT_STEP = "cart/updateCurrentStep";
export const CART_UPDATE_SUBSCRIBER = "cart/updateSubscriber";

// User
export const USER_FETCH = "user/Fetch";
export const USER_LOGIN = "user/login";
export const USER_LOGOUT = "user/logout";
export const USER_FORGOT_PASSWORD = "user/forgotPassword";
export const USER_REGISTER = "user/register";
export const USER_UPDATE = "user/updateUser";
export const USER_CHECK_AUTH = "user/checkAuth";
export const USER_CLEAR_MESSAGE = "user/slearMessage";

// Session, not namespaced
export const GET_SESSION_KEY = "getSessionKey";
export const CLEAR_SESSION = "clearSession";
export const CHECK_SESSION = "checkSession";

//Coverage Map
export const COVERAGE_FETCH = "coverage/fetch";
export const UPDATE_PLACE = "coverage/placeSet";
